import utils from '../utils';
//import customStyle from './map-style';

var mapInstance;

function initGoogleMap() {
	let map = document.querySelector('#gmap');
	if (map) {
		var apiKey = map.getAttribute('data-api');
		utils.loadScript('https://maps.googleapis.com/maps/api/js?key=' + apiKey, false, function () {
			startMap(map);
		});
	}
}

function startMap(map) {
	let latitude = Number(map.getAttribute("data-ltd")),
		longitude = Number(map.getAttribute("data-lng")),
		link = Number(map.getAttribute("data-link")),
		zoom = 20,
		maxZoom = 16,
		latLng = new window.google.maps.LatLng(latitude, longitude),
		customStyle = [
			{
				elementType: "geometry",
				stylers: [
					{
						color: "#f5f5f5",
					},
				],
			},
			{
				elementType: "labels.icon",
				stylers: [
					{
						visibility: "off",
					},
				],
			},
			{
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#616161",
					},
				],
			},
			{
				elementType: "labels.text.stroke",
				stylers: [
					{
						color: "#f5f5f5",
					},
				],
			},
			{
				featureType: "administrative.land_parcel",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#bdbdbd",
					},
				],
			},
			{
				featureType: "poi",
				elementType: "geometry",
				stylers: [
					{
						color: "#eeeeee",
					},
				],
			},
			{
				featureType: "poi",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#757575",
					},
				],
			},
			{
				featureType: "poi.park",
				elementType: "geometry",
				stylers: [
					{
						color: "#e5e5e5",
					},
				],
			},
			{
				featureType: "poi.park",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#9e9e9e",
					},
				],
			},
			{
				featureType: "road",
				elementType: "geometry",
				stylers: [
					{
						color: "#ffffff",
					},
				],
			},
			{
				featureType: "road.arterial",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#757575",
					},
				],
			},
			{
				featureType: "road.highway",
				elementType: "geometry",
				stylers: [
					{
						color: "#dadada",
					},
				],
			},
			{
				featureType: "road.highway",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#616161",
					},
				],
			},
			{
				featureType: "road.local",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#9e9e9e",
					},
				],
			},
			{
				featureType: "transit.line",
				elementType: "geometry",
				stylers: [
					{
						color: "#e5e5e5",
					},
				],
			},
			{
				featureType: "transit.station",
				elementType: "geometry",
				stylers: [
					{
						color: "#eeeeee",
					},
				],
			},
			{
				featureType: "water",
				elementType: "geometry",
				stylers: [
					{
						color: "#c9c9c9",
					},
				],
			},
			{
				featureType: "water",
				elementType: "labels.text.fill",
				stylers: [
					{
						color: "#9e9e9e",
					},
				],
			},
		];
		


	mapInstance = new window.google.maps.Map(map, {
		center: latLng,
		zoom,
		styles: customStyle,
		disableDefaultUI: true,
	});

	let marker = {
		google: new window.google.maps.Marker({
			position: latLng,
			map: mapInstance,
			icon: {
				url: window.location.origin + '/content/themes/dev/images/map-marker.svg', //TODO: set assets path
				scaledSize: new window.google.maps.Size(40, 40),
			},
		}),
	};
	
	marker.google.addListener("click", () => {
		return function () {
			window.open(link);
		}
	});


	mapInstance.setOptions({ maxZoom });

}

export default { initGoogleMap };